export { SvgArrowBack as ArrowBackIcon } from './ArrowBack';
export { SvgAvatar as AvatarIcon } from './Avatar';
export { SvgBack as BackIcon } from './Back';
export { SvgBlock as BlockIcon } from './Block';
export { SvgChat as ChatIcon } from './Chat';
export { SvgCheck as CheckIcon } from './Check';
export { SvgComment as CommentIcon } from './Comment';
export { SvgCopy as CopyIcon } from './Copy';
export { SvgDeviceMessage as DeviceMessageIcon } from './DeviceMessage';
export { SvgDislikeBtn as DislikeBtnIcon } from './DislikeBtn';
export { SvgDislikeFill as DislikeFillIcon } from './DislikeFill';
export { SvgEdit2 as Edit2Icon } from './Edit2';
export { SvgEyeOff as EyeOffIcon } from './EyeOff';
export { SvgEye as EyeIcon } from './Eye';
export { SvgFacebook as FacebookIcon } from './Facebook';
export { SvgFirstline as FirstlineIcon } from './Firstline';
export { SvgGlobalEdit as GlobalEditIcon } from './GlobalEdit';
export { SvgGlobal as GlobalIcon } from './Global';
export { SvgGoogle as GoogleIcon } from './Google';
export { SvgImagePlaceholder as ImagePlaceholderIcon } from './ImagePlaceholder';
export { SvgLikeBtn as LikeBtnIcon } from './LikeBtn';
export { SvgLikeFill as LikeFillIcon } from './LikeFill';
export { SvgLike as LikeIcon } from './Like';
export { SvgLinkedin as LinkedinIcon } from './Linkedin';
export { SvgLockBtn as LockBtnIcon } from './LockBtn';
export { SvgLockFill as LockFillIcon } from './LockFill';
export { SvgLock as LockIcon } from './Lock';
export { SvgMail as MailIcon } from './Mail';
export { SvgMention as MentionIcon } from './Mention';
export { SvgMoon as MoonIcon } from './Moon';
export { SvgMoreIcon as MoreIconIcon } from './MoreIcon';
export { SvgNext as NextIcon } from './Next';
export { SvgPrefixLink as PrefixLinkIcon } from './PrefixLink';
export { SvgPrev as PrevIcon } from './Prev';
export { SvgReddit as RedditIcon } from './Reddit';
export { SvgReload as ReloadIcon } from './Reload';
export { SvgSearchNormal as SearchNormalIcon } from './SearchNormal';
export { SvgSendBtn as SendBtnIcon } from './SendBtn';
export { SvgShare as ShareIcon } from './Share';
export { SvgShieldTick as ShieldTickIcon } from './ShieldTick';
export { SvgTelegram as TelegramIcon } from './Telegram';
export { SvgTwitter as TwitterIcon } from './Twitter';
export { SvgTwitterX as TwitterXIcon } from './TwitterX';
export { SvgUser as UserIcon } from './User';
export { SvgView as ViewIcon } from './View';
export { SvgXMark as XMarkIcon } from './XMark';
